// Begin when all essential assets are loaded and ready
document.addEventListener("DOMContentLoaded", function () {
    startAnimationArStatic24();
});

startAnimationArStatic24 = function () {

    ScrollTrigger.defaults({
        // markers: true,
    });

    //set up context
    let mm = gsap.matchMedia();

    //handle reduced motion accessible version
    let reduceMotionCB = document.querySelector(
        "#ar24-animation-toggle-switch"
    );
    reduceMotionCB.checked = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;
    reduceMotionCB.addEventListener("change", function () {
        gsap.matchMediaRefresh();
    });

    mm.add(
        {
            isMobile: "(max-width: 766px)",
            isTablet: "(min-width: 767px)",
            isDesktop: "(min-width: 1024px)",
            isWidescreen: "(min-width: 1160px)",
            isWidescreenPadded: "(min-width: 1200px)",
            is1600px: "(min-width: 1600px)",
        },
        (context) => {
            let {
                isMobile,
                isTablet,
                isDesktop,
                isWidescreen,
                isWidescreenPadded,
                is1600px,
            } = context.conditions;
            let reduceMotion = reduceMotionCB.checked;

            //abort all animation if reduced motion preference set
            if (reduceMotion) {
                document.getElementById("preloader").style.display = "none";
                return;
            }

            // PRELOADER
            let tlPreload = gsap.timeline({
                defaults: {
                    duration: 0.6,
                    ease: "power2.in",
                },
            });

            tlPreload
                .to(".preloader__spinner", {
                    duration: 1,
                    opacity: 0,
                })
                .to(
                    ".preloader__text",
                    {
                        duration: 0.5,
                        opacity: 0,
                    },
                    "-=0.25"
                )
                .to(
                    "#preloader",
                    {
                        duration: 1,
                        opacity: 0,
                        display: "none",
                    },
                    "-=0.25"
                );

            //BLOCK COVER
            let splitTitle = new SplitText("#cover-title", {
                type: "chars",
                tag: "span",
            });

            let tlCover = gsap.timeline({
                // scrollTrigger: {
                //     id: "cover",
                //     trigger: "#ar24-cover",
                //     start: "top 80%",
                //     // markers: true,
                // },
            });

            tlCover.set("#ar24-cover .cover-background svg", {
                rotate: 180,
            });

            tlCover.fromTo(
                "#ar24-cover .cover-background svg path",
                {
                    drawSVG: "50%",
                    opacity: 0,
                },
                {
                    opacity: 1,
                    drawSVG: "100%",
                    duration: 2,
                    stagger: 0.02,
                    ease: "power1.Out",
                }
                // "<"
            );
            tlCover.to(
                "#ar24-cover .cover-background svg",
                {
                    rotate: 270,
                    // repeat: -1,
                    duration: 120,
                    ease: "power1.Out",
                },
                "<20%"
            );
            tlCover.from(
                "#cover-title span",
                {
                    opacity: 0,
                    stagger: 0.05,
                    duration: 0.5,
                    ease: "power4.Out",
                },
                "<+=10%"
            );
            tlCover.from(
                "#ar24-cover .ar-cover-block__intro > *",
                {
                    opacity: 0,
                    duration: 1,
                    ease: "power4.inOut",
                },
                ">"
            );

            //BLOCK CEO
            let tlCeo = gsap.timeline({
                scrollTrigger: {
                    id: "ceo",
                    trigger: "#ar24-ceo",
                    start: "top 70%",
                    // markers: true,
                },
            });
            tlCeo.from(
                "#ar24-ceo .ar-side-image-block__content, #ar24-ceo .ar-facts-block__fact, #ar24-ceo .ar-side-image-block__image-container",
                {
                    opacity: 0,
                    y: 10,
                    stagger: 0.25,
                    duration: 0.5,
                }
            );

            //BLOCK snapshot
            let tlSnapshot = gsap.timeline({
                scrollTrigger: {
                    id: "snapshot",
                    trigger: "#ar24-snapshot",
                    start: "top 80%",
                    // markers: true,
                },
            });

            tlSnapshot.fromTo(
                "#ar24-snapshot .ar-snapshot-block__background svg path",
                {
                    drawSVG: "0%",
                    opacity: 0,
                },
                {
                    opacity: 1,
                    drawSVG: "100%",
                    duration: 0.25,
                    stagger: 0.01,
                    ease: "power1.Out",
                },
                "<"
            );
            tlSnapshot.from(
                "#ar24-snapshot .ar-snapshot-block__foreground__facts .fact-macro",
                {
                    opacity: 0,
                    y: 10,
                    duration: 0.5,
                    ease: "power1.Out",
                    stagger: {
                        each: 0.25,
                        onStart: unsuppressFactAnimation,
                    },
                },
                ">-0.5"
            );

            //BLOCK WWI
            let wwiDesktop = document.getElementById(
                "wwi-slider-wrapper-desktop"
            );
            let wwiMobile = document.getElementById(
                "wwi-slider-wrapper-mobile"
            );

            //show scroller only if widescreen
            wwiMobile.style.display = "block";
            wwiDesktop.style.display = "none";
            if (isWidescreenPadded) {
                wwiMobile.style.display = "none";
                wwiDesktop.style.display = "block";
            }
            let tlWwi = gsap.timeline({
                scrollTrigger: {
                    id: "wwi",
                    trigger: "#wwi-slider-wrapper-desktop",
                    start: "top 90%",
                    end: "bottom 90%",
                    // pin: true,
                    scrub: 1,
                    // pinSpacing: false,
                    // markers: true,
                },
            });
            tlWwi
                .fromTo(
                    "#wwi-slider-wrapper-desktop .wwi-row:nth-child(1)",
                    {
                        x: "-5%",
                    },
                    {
                        x: "0%",
                        ease: "power1.inOut",
                        duration: 2,
                    }
                )
                .fromTo(
                    "#wwi-slider-wrapper-desktop .wwi-row:nth-child(2)",
                    {
                        x: "5%",
                    },
                    {
                        x: "0%",
                        ease: "power1.inOut",
                        duration: 2,
                    },
                    "<"
                );

            //wwi cards

            //if touch device assume no hover capability and leave cards open
            if (ScrollTrigger.isTouch !== 1) {
                gsap.utils.toArray(".wwi-fund").forEach((fund) => {
                    let q = gsap.utils.selector(fund);
                    let initialY = 155;
                    gsap.set(q(".wwi-fund__overlay"), {
                        y: initialY,
                    });

                    fund.addEventListener("mouseover", () => {
                        tlOverlay = gsap
                            .timeline()
                            .to(q(".wwi-fund__overlay"), {
                                duration: 0.3,
                                y: 0,
                            });
                    });
                    fund.addEventListener("mouseleave", () => {
                        tlOverlay = gsap
                            .timeline()
                            .to(q(".wwi-fund__overlay"), {
                                duration: 0.3,
                                y: initialY,
                            });
                    });
                });
            }

            //BLOCK PRIORITIES
            if (isTablet) {
                let tlPrioritiesList = gsap.timeline({
                    scrollTrigger: {
                        id: "priorities-list",
                        trigger: "#ar24-priorities",
                        start: "top 50%",
                        // markers: true,
                    },
                });

                tlPrioritiesList.from(".ar-tile-block__tile", {
                    opacity: 0,
                    duration: 1,
                    y: 10,
                    stagger: 0.4,
                });

                //priorities 3 circle animation - Retired
                // let tlPrioritiesSVG = gsap.timeline({
                //     scrollTrigger: {
                //         id: "priorities",
                //         trigger: "#ar24-priorities",
                //         start: "top 50%",
                //         // markers: true,
                //     },
                // });

                // tlPrioritiesSVG

                //     .fromTo(
                //         "#ar24-priorities #outline_decarb, #ar24-priorities #outline_energy, #ar24-priorities #outline_natural",
                //         {
                //             drawSVG: "0%",
                //             opacity: 0,
                //         },
                //         {
                //             opacity: 1,
                //             drawSVG: "100%",
                //             duration: 1,
                //             stagger: 0.5,
                //             ease: "power1.inOut",
                //         }
                //     )
                //     .from(
                //         "#text_decarbonise, #text_natural, #text_energy",
                //         {
                //             opacity: 0,
                //             y: 4,
                //             stagger: 0.5,
                //             duration: 1,
                //             delay: 0,
                //         },
                //         "<0.7"
                //     )
                //     .fromTo(
                //         "#ar24-priorities #spectrum",
                //         {
                //             rotate: 0,
                //             transformOrigin: "50% 50%",
                //         },
                //         {
                //             rotate: 360,
                //             duration: 120,
                //             repeat: -1,
                //         },
                //         "<"
                //     )
                //     .from(
                //         "#ar24-priorities #spectrum",
                //         {
                //             opacity: 0,
                //             scale: 0.5,
                //             duration: 1.5,
                //         },
                //         "<"
                //     );
            }

            //BLOCK VIDEO
            let video = document.getElementById("video");
            let videoContainer = document.getElementById("video-container");
            let videoCenter = document.getElementById("video-center");

            //calculate scale ratio
            //90% window width / video resting width
            let videoFullWidth = window.innerWidth;
            let videoRestingWidth =
                document.getElementById("video-frame").offsetWidth;
            let videoScaleRatio = (0.9 * videoFullWidth) / videoRestingWidth;
            // console.log("videoFullWidth", videoFullWidth);
            // console.log("videoRestingWidth", videoRestingWidth);
            // console.log("videoScaleRatio", videoScaleRatio);

            //Only scale up if window width allows enough movement for it to be worthwhile
            if (isWidescreen & (videoScaleRatio > 1.1)) {
                gsap.set(videoContainer, { height: "150vh" });
                gsap.set(videoCenter, { height: "100vh" });

                //play video background on enter/exit
                let tlVideo = ScrollTrigger.create({
                    id: "video-player",
                    trigger: videoContainer,
                    start: "top bottom",
                    end: "bottom top",
                    onToggle: (self) =>
                        self.isActive ? video.play() : video.pause(),
                    // markers: true,
                });

                //video foreground

                let tlVideoContainer = gsap.timeline({
                    scrollTrigger: {
                        id: "video-container",
                        trigger: videoContainer,
                        start: "top top",
                        end: "bottom bottom",
                        pin: true,
                        // anticipatePin: 1,
                        scrub: 1,
                        pinSpacing: false,
                        toggleActions: "play none none reset",
                        // snap: {
                        //     snapTo: "labelsDirectional", // snap to the closest label in the timeline
                        //     duration: { min: 0.2, max: 0.2 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                        //     delay: 0, // wait 0.2 seconds from the last scroll event before doing the snapping
                        //     ease: "linear", // the ease of the snap animation ("power3" by default)
                        // },
                        // onToggle: (self) =>
                        //     self.isActive ? video.play() : video.pause(),
                        // markers: true,
                    },
                });
                gsap.set(
                    "#video-text-a, #video-text-b, #video-text-c, #video-text-d, #video-text-e",
                    { opacity: 0 }
                );
                tlVideoContainer
                    .add(() => {
                        gsap.timeline()
                            .to(
                                "#video-text-a, #video-text-b, #video-text-c, #video-text-d",
                                {
                                    opacity: 1,
                                    duration: 0.5,
                                    stagger: 0.5,
                                }
                            )
                            .to("#video-text-e", {
                                opacity: 1,
                                duration: 0.5,
                                onStart: unsuppressFactAnimation,
                            });
                    })
                    //new scale method supercedes individual width and font size manipulation for smoother animation and less jerky font effect
                    .fromTo(
                        "#video-frame",
                        {
                            scale: videoScaleRatio,
                        },
                        {
                            scale: 1,
                            duration: 20,
                        },
                        "<40"
                    );
                // .from(
                //     "#video-frame",
                //     {
                //         width: "90%",
                //         // height: "auto",
                //         duration: 20,
                //         ease: "linear",
                //     },
                //     "<40"
                // )
                // .fromTo(
                //     "#video-text-a, #video-text-b, #video-text-c, #video-text-d, #video-text-e ",
                //     {
                //         scale: 1.52,
                //     },
                //     {
                //         scale: 1,
                //         duration: 20,
                //     },
                //     "<"
                // )
                // .from(
                //     "#video-text-a .fact-macro__fact, #video-text-b .fact-macro__fact, #video-text-c .fact-macro__fact, #video-text-d .fact-macro__fact",
                //     {
                //         fontSize: 75,
                //         duration: 20,
                //     },
                //     "<"
                // )
                // .from(
                //     "#video-text-a .fact-macro__description, #video-text-b .fact-macro__description, #video-text-c .fact-macro__description, #video-text-d .fact-macro__description",
                //     {
                //         fontSize: 25,
                //         duration: 20,
                //     },
                //     "<"
                // )
                // .from(
                //     "#video-text-e .fact-macro__fact",
                //     {
                //         fontSize: 140,
                //         duration: 20,
                //     },
                //     "<"
                // )
                // .from(
                //     "#video-text-e .fact-macro__description",
                //     {
                //         fontSize: 30,
                //         duration: 20,
                //     },
                //     "<"
                // )
            }

            //BLOCK DOWNLOAD
            let tlDownload = gsap.timeline({
                scrollTrigger: {
                    id: "download",
                    trigger: "#ar24-download",
                    start: "top 80%",
                    // markers: true,
                },
            });
            tlDownload.from(
                "#ar24-download .ar-side-image-block__content-container, #ar24-download .ar-side-image-block__document-container",
                {
                    opacity: 0.5,
                    y: 10,
                    stagger: 0.25,
                    duration: 0.5,
                }
            );
        }
    );

    //Remove animation supression class and trigger counter
    //TODO: Abstract for reuse on rest of site.
    function unsuppressFactAnimation() {
        //Remove animation supression class
        let element = this.targets()[0];
        $(element)
            .children(".ar-animation__suppress")
            .removeClass("ar-animation__suppress");

        //re-run the counter code

        $(
            ".ar-block-page .fact-macro__fact:not(.ar-animation__active, .ar-animation__suppress)"
        ).each(function (index, element) {
            let matched = element.innerHTML.match(/[\d,\.]+/);

            if (matched) {
                let number = matched.toString();
                let decimalPlaces = 0;
                let matchedDecimalPlaces = number.match(/\.[\d]+/);
                if (matchedDecimalPlaces) {
                    decimalPlaces = matchedDecimalPlaces[0].length - 1;
                }

                let separator = "";
                if (number.match(/[,]+/)) {
                    separator = ",";
                }

                let index = element.innerHTML.indexOf(number);
                let prefix = element.innerHTML.substring(0, index);
                let suffix = element.innerHTML.substring(index + number.length);

                let options = {
                    decimalPlaces: decimalPlaces,
                    separator: separator,
                    prefix: prefix,
                    suffix: suffix,
                };

                let counter = new CountUp(
                    element,
                    number.replace(",", ""),
                    options
                );
                if (!counter.error) {
                    counter.start();
                } else {
                    console.error(counter.error);
                }

                element.classList.add("ar-animation__active");
            }
        });
    }
};
